import Api from '@/api/Api'
import store from '../store'

export default {
  // Employee
  async getEmployeeList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('hrm/employees', { params }))
  },

  async getEmployeeSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`hrm/employees/${id}`))
  },

  async createEmployee (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('hrm/employees', data, options))
  },

  async importEmployee (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('hrm/employees/import', data, options))
  },

  async updateEmployee (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`hrm/employees/${id}`, data, options))
  },

  async deleteEmployee (id = '') {
    return store.dispatch('checkResponseApi', await Api().delete(`hrm/employees/${id}`))
  },

  // Department
  async getDepartmentList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('hrm/departments', { params }))
  },

  async getDepartmentSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`hrm/departments/${id}`))
  },

  async createDepartment (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('hrm/departments', data, options))
  },

  async updateDepartment (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`hrm/departments/${id}`, data, options))
  },

  async updateDepartmentAssign (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`hrm/departments/${id}/assign-employees`, data, options))
  },

  async deleteDepartment (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`hrm/departments/${id}`, { data }, options))
  },

  // Position
  async getPositionList (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('hrm/positions', { params }))
  },

  async getPositionSingle (id = '') {
    return store.dispatch('checkResponseApi', await Api().get(`hrm/positions/${id}`))
  },

  async createPosition (data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('hrm/positions', data, options))
  },

  async updatePosition (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`hrm/positions/${id}`, data, options))
  },

  async updatePositionAssign (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().put(`hrm/positions/${id}/assign-employees`, data, options))
  },

  async deletePosition (id = '', data = {}) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().delete(`hrm/positions/${id}`, { data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/HrmService.js